<div class="label-count-row">
    <label-color-optional
        [labelData]="labelRowData"
        class="label-count-row__label"
    ></label-color-optional>
    <div class="label-count-row__value">{{ labelRowData.count }}</div>
</div>
